<template>
	<div class="stories-manage col" gutter="10">
		<Title title="管理報名故事"></Title>
		<SearchBar :searchText="searchText" placeholder="故事名稱、小組名稱、故事帳號、輔導員" @search="handleSearch"></SearchBar>
		<div class="col top" gutter="20">
			<div class="row">
				<el-button type="primary" @click="routerTo('uploadYoutube')">上傳Youtube</el-button>
				<el-button type="info" @click="download()">下載所有資料</el-button>
			</div>
			<div class="filter row" align-y="center" gutter="10">
				<el-button class="delete-btn" type="info" icon="el-icon-delete" @click="deleteStories"></el-button>
				<el-radio-group v-model="status" @change="handleStatusChange">
					<el-radio-button label="全部"></el-radio-button>
					<el-radio-button label="已完成"></el-radio-button>
					<el-radio-button label="待審核"></el-radio-button>
					<el-radio-button label="未完成"></el-radio-button>
					<el-radio-button label="已退件"></el-radio-button>
				</el-radio-group>
				<el-select v-model="session" placeholder="屆數" @change="handleSessionChange">
					<el-option v-for="option in sessionFilters" :key="option" :label="option" :value="option" />
				</el-select>
				<el-button type="info" @click="clearFilter" size="mini">清除</el-button>
			</div>
			<el-pagination class="layout-row layout-justify-center" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="storyList.total">
			</el-pagination>
			<el-table :data="storyList.list" style="width: 100%" :default-sort="{prop: 'account', order: 'descending'}" @selection-change="handleSelectionChange">
				<el-table-column type="expand" width="50">
					<pre slot-scope="{row}">{{row.failed_message}}</pre>
				</el-table-column>
				<el-table-column type="selection" width="50" />
				<el-table-column prop="account" label="故事帳號" sortable width="150" />
				<el-table-column prop="team_name" label="小組名稱" width="180" />
				<el-table-column prop="story_name" label="故事名稱" width="180" />
				<el-table-column prop="is_participate" label="是否分享" align="center">
					<el-tag slot-scope="{row}" :type="!row.is_participate && 'info' || ''">{{row.is_participate ? "是" : "否"}}</el-tag>
				</el-table-column>
				<el-table-column label="輔導員" width="180">
					<template slot-scope="{row}">
						{{getCounselors(row.counselors)}}
					</template>
				</el-table-column>
				<el-table-column prop="update_time" label="更新時間" sortable>
					<template slot-scope="{row}">
						{{row.update_time | moment("YYYY-MM-DD, HH:mm")}}
					</template>
				</el-table-column>
				<el-table-column prop="apply_status" label="狀態" sortable>
					<template slot-scope="{row}">
						{{getStatueString(row.apply_status)}}
					</template>
				</el-table-column>
				<el-table-column prop="" label="檢視" width="100">
					<template slot-scope="{row}">
						<router-link :to="{name: 'manageStory', params: {id: row.id}}">檢視</router-link>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="layout-row layout-justify-center" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="storyList.total">
			</el-pagination>
		</div>

		<div style="width:0;height:0;overflow:hidden;">
			<table ref="downloadTable" v-html="tbody" border="1"></table>
		</div>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import xlsx from "@/libs/xlsx";
import _ from "lodash";
import moment from "moment-timezone";

export default {
	mixins: [xlsx],
	data() {
		return {
			session: "",
			status: "全部",
			currentPage: 1,
			pageSize: 10,
			searchText: "",
			multipleSelection: [],
			downloadList: [],
			tbody: ""
		};
	},
	computed: {
		...mapState("story", ["storyList"]),
		query() {
			return {
				page: this.currentPage,
				size: this.pageSize,
				status: this.status,
				text: this.searchText,
				session: this.session
			};
		},
		sessionFilters() {
			const start = 2018;
			const now = new Date().getFullYear();
			let arr = [];
			for (let i = start; i <= now; i++) arr.push(i);
			return arr;
		}
	},
	watch: {
		async $route(val) {
			await this.searchBackendAllStories(this.query);
		}
	},
	methods: {
		...mapActions("story", ["searchBackendAllStories", "deleteMultiStories", "getAllStories"]),
		getCounselors(counselors) {
			let str = "";
			for (let index in counselors) {
				if (index != 0) str = str + ", ";
				str = str + counselors[index].name;
			}
			return str;
		},
		getStatueString(status) {
			switch (status) {
				case 1:
					return "未完成";
				case 2:
					return "待審核";
				case 3:
					return "已退件";
				case 4:
					return "審核通過";
				case 5:
					return "評審評分中";
				case 6:
					return "已評分";
			}
		},
		clearFilter() {
			const query = {}
			this.init({ query });
			this.$router.replace({ query });
		},
		handleSessionChange(val) {
			this.session = val;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleStatusChange(val) {
			this.status = val;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleCurrentChange(value) {
			this.currentPage = value;
			this.$router.replace({ query: this.query });
		},
		handleSearch(searchText) {
			this.searchText = searchText;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleSizeChange(value) {
			this.pageSize = value;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		init({ query }) {
			this.currentPage = Number(query.page) || 1;
			this.pageSize = Number(query.size) || 10;
			this.status = query.status || "全部";
			this.searchText = query.text || "";
			this.session = query.session || "";
		},
		deleteStories() {
			let data = [];
			for (let select of this.multipleSelection) {
				data.push(select.id);
			}
			if (data.length > 0) {
				this.$confirm(`確定刪除故事？`, "提示", {
					confirmButtonText: "確定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(async () => {
					try {
						await this.deleteMultiStories(data);
						await this.searchBackendAllStories(this.query);
						this.$message.success("刪除成功");
					} catch (e) {
						this.$message.error(e.message);
					}
				}).catch(() => { });
			}
		},
		routerTo(name) {
			this.$router.push({ name: name });
		},
		async download() {
			this.downloadList = await this.getAllStories({ session: this.session });
			let tbody = `<tr>
				<th colspan="7">送出故事資料</th>
				<th colspan="8">故事資料</th>
				<th colspan="3">證書寄送地址</th>
				<th colspan="">輔導員資料</th>
				<th colspan="7">超級英雄資料</th>
			</tr>`;
			tbody += `<tr>
				<th>報名成功</th>
				<th>小推手人數</th>
				<th>影片連結</th>
				<th>照片</th>
				<th>故事分享表</th>
				<th>創用CC</th>
				<th>參與分享季</th>

				<th>故事年份</th>
				<th>故事編號</th>
				<th>故事名稱</th>
				<th>感受到的問題</th>
				<th colspan="3">SDGs</th>
				<th>最後更新</th>

				<th>收件人</th>
				<th>郵遞區號</th>
				<th>縣市</th>
				<th>地址</th>

				<th>姓名</th>

				<th>姓名</th>
				<th>羅馬拼音</th>
				<th>年級</th>
				<th>年齡</th>
				<th>法代姓名</th>
				<th>學校單位（英文）</th>
				<th>學校單位（中文）</th>
			</tr>`;
			this.downloadList
				.forEach(row => {
					if (row.team_members) {
						let row_num = row.team_members.length;
						for (let i = 0; i < row_num; i++) {
							tbody += "<tr>"
							tbody += `
							<td>${row.apply_status >= 4 ? "Y" : "N"}</td>
							<td>${row_num || ""}</td>
							<td>${row.video && row.video.src || ""}</td>
							<td>${row.progress.bar_list[3] ? "Y" : "N"}</td>
							<td>${row.pdf_list && row.pdf_list.length > 0 ? "Y" : "N"}</td>
							<td>${row.progress.bar_list[5] ? "Y" : "N"}</td>
							<td>${row.is_participate ? "Y" : "N"}</td>

							<td>${/^CHI-/.test(row.account) && row.account.match(/[0-9]{4}/) || ""}</td>
							<td>${row.account || ""}</td>
							<td>${row.story_name || ""}</td>
							<td>${row.problem || ""}</td>
							<td>${row.sdgs && row.sdgs[0] || ""}</td>
							<td>${row.sdgs && row.sdgs[1] || ""}</td>
							<td>${row.sdgs && row.sdgs[2] || ""}</td>
							<td>${row.update_time && moment(row.update_time).tz("Asia/Taipei").format("YYYY-MM-DD, HH:mm") || ""}</td>

							<td>${row.certificate_address && row.certificate_address.recipient || ""}</td>
							<td>${row.certificate_address && row.certificate_address.zip || ""}</td>
							<td>${row.certificate_address && row.certificate_address.city || ""}</td>
							<td>${row.certificate_address && row.certificate_address.address || ""}</td>

							<td>${row.counselors.map(counselor => `[${counselor.name}]-[${counselor.email}]-[${counselor.phone}]`).join("<br>") || ""}</td>

							<td>${row.team_members[i] && row.team_members[i].name || ""}</td>
							<td>${row.team_members[i] && row.team_members[i].wade_giles || ""}</td>
							<td>${row.team_members[i] && row.team_members[i].grade || ""}</td>
							<td>${row.team_members[i] && row.team_members[i].age || ""}</td>
							<td>${row.team_members[i] && row.team_members[i].parent || ""}</td>
							<td>${row.team_members[i] && row.team_members[i].department_en || ""}</td>
							<td>${row.team_members[i] && row.team_members[i].department_zh || ""}</td>`
							tbody += "</tr>"
						}
					}
				});
			this.tbody = tbody;
			this.$nextTick(() => {
				this.saveAsXLSX(this.$refs["downloadTable"], "全球孩童創意行動挑戰.xlsx");
			});
		}
	},
	async created() {
		this.init(this.$route);
		await this.searchBackendAllStories(this.query);
	},
	mounted() { },
	components: {
		Title,
		SearchBar
	}
}
</script>

<style lang="scss" scoped>
.filter {
	margin-left: 25px;

	.delete-btn {
		margin-right: 10px;
	}
}

.feature {
	margin-bottom: 20px;
}

.el-pagination {
	margin-top: 15px;
}

th {
	text-align: center;
}
</style>